import React from 'react';
import './App.css'; // Make sure this matches your CSS file name

function App() {
  // --- CUSTOMIZE YOUR WHATSAPP INFO HERE ---
  // Replace with your actual WhatsApp number (include country code, no + or spaces)
  const phoneNumber = "12345678";
  
  // This safely encodes the spaces in your message for a web link
  const whatsappLink = `https://wa.me/${phoneNumber}`;

  return (
    <div className="app-container">
      {/* Navigation Header */}
      <nav>
        <div className="logo">TIMELESS GLAM BY NEHA MUA</div>
        <div className="nav-links">
          <a href="#services">Services</a>
          <a href="#contact">Book Now</a>
        </div>
      </nav>

      {/* Main Hero Banner */}
      <section className="hero">
        <h1>Unveil Your Timeless Beauty</h1>
        <p>Professional makeup artistry tailored to enhance your natural glow. From bridal elegance to high-fashion editorial, look flawless for your most special moments.</p>
        
        <a href={whatsappLink} className="whatsapp-btn" target="_blank" rel="noopener noreferrer" id="contact">
          <i className="fab fa-whatsapp"></i> Book Appointment
        </a>
      </section>

      {/* Services Section */}
      <section id="services" className="services">
        <h2>Signature Services</h2>
        <div className="grid">
          <div className="card">
            <h3>Bridal Perfection</h3>
            <p>Long-lasting, radiant makeup that makes you the star of your wedding day. Includes a comprehensive pre-wedding consultation and trial run.</p>
          </div>
          <div className="card">
            <h3>Event Glamour</h3>
            <p>Turn heads at your next gala, prom, or birthday party with a customized, flawless full-face application that suits your outfit and style.</p>
          </div>
          <div className="card">
            <h3>Photoshoot Ready</h3>
            <p>High-definition makeup designed specifically to look incredible under harsh studio lighting and modern, high-resolution camera lenses.</p>
          </div>
        </div>
      </section>

      {/* Footer Area */}
      <footer>
        <h2>TIMELESS GLAM BY NEHA MUA</h2>
        <p>We go timeless, we go priceless, we go free</p>
        
        <a href={whatsappLink} className="whatsapp-btn footer-btn" target="_blank" rel="noopener noreferrer">
          <i className="fab fa-whatsapp"></i> Chat With Us
        </a>
        
        <p className="copyright">&copy; {new Date().getFullYear()} Timeless Glam. All Rights Reserved.</p>
      </footer>
    </div>
  );
}

export default App;